import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { addToCarts, setCart } from "../../redux/actions";
import AddingProductToCartModal from "../../components/modals/AddingProductToCartModal";

const ProductComparison = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user_data = useSelector((state) => state?.user_data?.user_data) ?? {};
  const region = useSelector((state) => state.region.region);

  const [variation, setVariation] = useState(false);
  const [quant, setQuant] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [locationList, setLocationList] = useState([]);

  let passedData = {};
  let rfq_data = {};
  let rfq_list = [];

  if (location?.state) {
    passedData = location?.state;
    rfq_data = passedData.comparisonData || {};

    rfq_list = [rfq_data];
  }

  // Load RFQ list from local storage
  const [storedRFQList, setStoredRFQList] = useState(() => {
    return JSON.parse(localStorage.getItem("comparison_list")) || [];
  });

  // Add new product only if it doesn't exist (based on productID)
  useEffect(() => {
    if (rfq_list.length > 0) {
      const newProduct = rfq_list[0]; // Get the new product

      // Check if the product already exists
      const productExists = storedRFQList.some(
        (item) => item.code === newProduct.code
      );

      if (productExists) {
        toast.info("This product is already in the comparison list.");
        return; // Do not add again
      }

      // Check if the stored list already has 4 items
      if (storedRFQList.length >= 4) {
        toast.error("You can only add up to 4 items only");
        return; // Stop execution if the limit is reached
      }

      const updatedList = [...storedRFQList, newProduct];

      // Update state and local storage
      setStoredRFQList(updatedList);
      localStorage.setItem("comparison_list", JSON.stringify(updatedList));
    }
  }, [rfq_list]); // Trigger only when rfq_list changes

  const handleDelete = (index) => {
    let updatedList = [...storedRFQList];

    // Remove the item at the given index
    updatedList.splice(index, 1);

    // Update state
    setStoredRFQList(updatedList);

    // Update local storage
    localStorage.setItem("comparison_list", JSON.stringify(updatedList));

    // Dispatch event to trigger the useEffect listener
    window.dispatchEvent(new Event("comparisonListUpdated"));
  };

  const addToCart = async (selectedVariation, quantity) => {
    setVariation(selectedVariation);
    setQuant(quantity);
    //guest cart

    const toastId = "addToCartError";
    const successToastId = "addToCartSuccess";

    if (!user_data?.locations) {
      let cartId = localStorage.getItem("cartIdKey");

      if (!cartId) {
        cartId = Math.random().toString(36).substring(2, 10);
        localStorage.setItem("cartIdKey", cartId);
      }
      const locationId = cartId;
      try {
        const createCart = await addToCarts(
          selectedVariation,
          quantity,
          locationId,
          region,
          dispatch
        );

        if (createCart) {
          dispatch(setCart(createCart));

          //navigate("/cart/one-time");
          setTimeout(() => {
            if (!toast.isActive(successToastId)) {
              toast.success(
                <div
                  style={{
                    width: "380px",
                    height: "120px",
                  }}
                >
                  <p className="mt-10 mb-20">Product added to cart</p>
                  <div className="d-flex justify-content-between align-items-center gap-3">
                    <button
                      className="btn btn-sm p-10 bg-main-product-50 hover-bg-main-product-50 flex-fill text-center me-2"
                      onClick={() => toast.dismiss(successToastId)}
                    >
                      Shop More
                    </button>

                    <button
                      className="btn btn-sm p-10 bg-main-product-50 hover-bg-main-product-50 flex-fill text-center ms-2"
                      onClick={() => (window.location.href = "/cart/one-time")}
                    >
                      View Cart
                    </button>
                  </div>
                </div>,
                { toastId: successToastId }
              );
            }
          }, 500);
          return;
        }
      } catch (error) {
        console.log(error);
      }

      return;
    } else if (user_data?.locations?.length === 1) {
      const locationId = user_data?.locations[0]?.id || undefined;
      try {
        const createCart = await addToCarts(
          selectedVariation,
          quantity,
          locationId,
          region,
          dispatch
        );
        dispatch(setCart(createCart));

        //navigate("/cart/one-time");
        setTimeout(() => {
          if (!toast.isActive(successToastId)) {
            toast.success(
              <div
                style={{
                  width: "380px",
                  height: "120px",
                }}
              >
                <p className="mt-10 mb-20">Product added to cart</p>
                <div className="d-flex justify-content-between align-items-center gap-3">
                  <button
                    className="btn btn-sm p-10 bg-main-product-50 hover-bg-main-product-50 flex-fill text-center me-2"
                    onClick={() => toast.dismiss(successToastId)}
                  >
                    Shop More
                  </button>

                  <button
                    className="btn btn-sm p-10 bg-main-product-50 hover-bg-main-product-50 flex-fill text-center ms-2"
                    onClick={() => (window.location.href = "/cart/one-time")}
                  >
                    View Cart
                  </button>
                </div>
              </div>,
              { toastId: successToastId }
            );
          }
        }, 500);

        return;
      } catch (error) {
        console.log(error);
      }
      return;
    } else if (user_data?.locations?.length === 0) {
      navigate("/self-service/mycompany/actions");
      if (!toast.isActive(toastId)) {
        toast.error(
          "Please add delivery location to add the product in carts.",
          { toastId }
        );
      }
      return;
    } else if (user_data?.locations?.length > 1) {
      setLocationList(user_data?.locations);
      setIsModalOpen(true);
    } else {
      console.warn("noo actions ");
    }
  };

  const attributes = storedRFQList?.reduce((acc, data) => {
    if (data?.productvariations?.attributes) {
      acc.push(...data.productvariations.attributes);
    }
    return acc;
  }, []);

  //   const allAttributes = storedRFQList.flatMap(
  //     (data) => data?.productvariations?.attributes || []
  //   );

  const groupedAttributes = {};

  attributes.forEach((attr) => {
    const key = attr.name;
    const valueWithUnit = attr.value + (attr.unit ? attr.unit : "");

    if (!groupedAttributes[key]) {
      groupedAttributes[key] = [];
    }
    groupedAttributes[key].push(valueWithUnit);
  });

  // Step 3: Ensure each attribute list has equal length (fill with '-')
  const maxLength = Math.max(
    ...Object.values(groupedAttributes).map((arr) => arr.length)
  );

  Object.keys(groupedAttributes).forEach((key) => {
    while (groupedAttributes[key].length < maxLength) {
      groupedAttributes[key].unshift("-"); // Add '-' at the beginning
    }
  });

  // Convert object to array format [[key, values]]
  const formattedArray = Object.entries(groupedAttributes);

  console.log(storedRFQList);

  return (
    <>
      {isModalOpen && (
        <AddingProductToCartModal
          onClose={() => setIsModalOpen(false)}
          locationList={locationList}
          productVariation={variation}
          quantity={quant}
          region={region}
        />
      )}
      <section className="trending-productss pt-10">
        <div className="container container-lg">
          <div className="section-heading">
            <div className="flex-between flex-wrap gap-8">
              <h2 className="mb-0 text-blue">COMPARE PRODUCTS</h2>
            </div>
          </div>
        </div>
        <div className="container container-lg">
          <div className="row gy-4 g-12">
            {storedRFQList &&
              storedRFQList &&
              storedRFQList.map((data, index) => (
                <div className="col-xxl-2 col-lg-3 col-sm-4 col-6" key={index}>
                  <div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 d-flex flex-column h-100">
                    <Link
                      to={`/product-details/${encodeURIComponent(
                        data?.url?.en?.startsWith("/")
                          ? data?.url?.en.slice(1)
                          : data?.url?.en
                      )}`}
                      className="product-card__thumb flex-center"
                    >
                      <img
                        className="product_list_image"
                        src={
                          data?.image
                            ? data?.image
                            : "/assets/images/logo/Image-coming-soon.png"
                        }
                        alt={data?.name || "Product Image"} // Add alt text for accessibility
                      />
                    </Link>

                    <div className="product-card__content mt-12 d-flex flex-column justify-between flex-grow">
                      {/* Title block with fixed height */}
                      <h6
                        className="title text-lg fw-semibold mb-8"
                        style={{ minHeight: "3.5em", lineHeight: "1.75em" }} // ≈ 2 lines
                      >
                        <Link
                          to="/product-details"
                          className="link text-line-2"
                        >
                          {data?.name}
                        </Link>
                      </h6>

                      <div className="mt-auto d-flex flex-column gap-8">
                        <a
                          className="text-blue bg-blue"
                          href="#"
                          onClick={() => handleDelete(index)}
                        >
                          Remove from comparison
                        </a>
                        <button
                          className="product-card__carts btn bg-main-product-50 hover-bg-main-product-50 hover-text-white py-11 px-24  flex-align gap-8 position-absolute inset-block-start-0 inset-inline-end-0 me-16 mt-16"
                          onClick={(e) => {
                            e.preventDefault();
                            addToCart(data?.productvariations, 1);
                          }}
                        >
                          Add
                          <span className="icon text-xl d-flex">
                            <i className="ph ph-shopping-cart"></i>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className="container container-lg">
          <div className="row gy-4">
            <div className="col-12">
              <div className="position-relative transition-2 offer-card overflow-hidden p-16 mb-4">
                <div className="py-xl-4">
                  <h3 className="text-black mb-8">General info</h3>
                </div>
                {storedRFQList && storedRFQList.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table  table-fixed">
                      <tbody>
                        {["brand", "price", "unit", "supplier"].map(
                          (key, i) => (
                            <tr
                              key={i}
                              className="border-bottom border-neutral-100"
                            >
                              <td
                                className="text-black"
                                style={{ width: "150px" }}
                              >
                                <b>
                                  {key.charAt(0).toUpperCase() + key.slice(1)}
                                </b>
                              </td>
                              {storedRFQList.map((data, index) => (
                                <td
                                  key={index}
                                  className="text-black text-center"
                                  style={{ minWidth: "150px" }}
                                >
                                  {typeof data?.[key] === "object"
                                    ? JSON.stringify(data?.[key])
                                    : data?.[key] || "-"}
                                </td>
                              ))}
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-black">No data available</p>
                )}
              </div>

              <div className="position-relative transition-2 offer-card overflow-hidden p-16">
                <div className="py-xl-4">
                  <h3 className="text-black mb-8">Specific info</h3>
                </div>
                {formattedArray && formattedArray.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table  table-fixed">
                      <tbody>
                        {formattedArray.map((data, index) => (
                          <tr
                            key={index}
                            className="border-bottom border-neutral-100"
                          >
                            <td
                              className="text-black"
                              style={{ width: "150px" }}
                            >
                              <b>{data[0]}</b>
                            </td>
                            {data[1].map((value, valueIndex) => (
                              <td
                                key={valueIndex}
                                className="text-black text-center"
                                style={{ minWidth: "150px" }}
                              >
                                {value}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-black">No data available</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductComparison;
